<template>
  <div>
    <!-- Element UI 图片预览器 -->
    <el-image-viewer 
      v-if="showViewer" 
      :url-list="imageUrls" 
      :on-close="closeViewer"
    >
    </el-image-viewer>
    <el-dialog :title="title" top='5vh' :visible.sync="openReviewRecords" width="60%">
      <div slot="title" class="dialog-title">
        {{ title }}
      </div>
      <div :class="type === 'goodsFile'?'good-file':'approve-history'">
        <template v-if="type === 'service'|| type === 'customer'">
          <el-timeline class="t-left" placement>
            <el-timeline-item v-for="(item, index) in reviewList" :key="index">
              <p>
                <el-tag size="mini" :type="getApproveType(item.approveState)">
                  {{ item.approveState | approveType }}
                </el-tag>
                <span class="reason-text" style="padding-left: 10px">{{ item.approveTime | getTimeDate }}</span>
              </p>
              <div v-if="type=== 'customer'">
                <p class="reason-text">{{ '运营审核原因：' }}{{ item.approveSuggest ||'-'}}</p>
              </div>
              <div v-else>
                <p class="reason-text">{{ '运营审核原因：' }}{{ issusesFormat(item.issues) }}</p>
                <p v-if="currentTab?.value !== 'Y'" class="reason-text">{{ '业务员查看原因：' }}{{ item.issuesDesc || '-' }}</p>
                <!-- 只有第一个状态为不合格或部分合格且有附件的记录才展示图片 -->
                <div v-if="index === firstQualifiedIndex && item.attach?.length">
                  <a class="txt-color" @click="openViewer(item.attach)">查看图片</a>
                </div>
              </div>
              
            </el-timeline-item>
          </el-timeline>
        </template>
        <template v-if="type === 'tenant'">
          <el-timeline class="t-left" placement>
            <el-timeline-item v-for="(item, index) in reviewList" :key="index">
              <p>
                <el-tag size="mini" :type="getApproveType(item.tenantApproveState)">
                  {{ item.tenantApproveState | tenantApproveType }}
                </el-tag>
                <span class="reason-text" style="padding-left: 10px">{{ item.tenantApproveTime | getTimeDate }}</span>
              </p>
              <p v-if="item.tenantApproveState === 'N'" class="reason-text">{{ '原因：' }}{{ item.tenantReply || '-' }}</p>
              <!-- 只有第一个状态为不满意(N)的记录才展示图片 -->
              <div v-if="index === firstUnqualifiedIndex && item.attach?.length">
                <a class="txt-color" @click="openViewer(item.attach)">查看图片</a>
              </div>
            </el-timeline-item>
          </el-timeline>
        </template>
        <template v-if="type === 'goodsFile'">
          <ul>
            <li v-for="(item,index) in reviewList" :key="index" style="list-style: none">
              <img v-if="item.path" :src="item.path" @click="viewPicDetail(item.path)" width="100%" height="auto" :alt="item.fileName">
            </li>
          </ul>
        </template>
      </div>
      <div class="operte-btns">
        <div class="btn cancel" @click="closedBox()">关闭</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
  },
  props: [],
  data() {
    return {
      openReviewRecords: false,
      title: '',
      type: '',
      reviewList: [],
      // 图片预览器状态
      showViewer: false,
      imageUrls: [],
      // 当前选中的 tab 信息
      currentTab: null,
    };
  },
  computed: {
    // 获取第一个状态为不合格(N)或部分合格(P)的记录索引
    firstQualifiedIndex() {
      return this.reviewList.findIndex(item => 
        item.approveState === 'N' || item.approveState === 'P'
      );
    },
    // 获取第一个状态为不满意(N)的记录索引
    firstUnqualifiedIndex() {
      return this.reviewList.findIndex(item => 
        item.tenantApproveState === 'N'
      );
    },
  },
  filters: {
    approveType(val) {
      let objStr = {
        Y: '合格',
        N: '不合格',
        P: '部分合格',
      };
      return objStr[val] || '-';
    },
    tenantApproveType(val) {
      let objStr = {
        Y: '满意',
        N: '不满意',
      };
      return objStr[val] || '-';
    },
  },
  created() {
    this.$root.$on('viewReviewRecords', this.handleViewReviewRecords);
    this.$root.$on('viewGoodsFile', this.handleViewGoodsFile);
  },
  activated() {
    // keep-alive 缓存后重新进入页面时触发
    this.$root.$on('viewReviewRecords', this.handleViewReviewRecords);
    this.$root.$on('viewGoodsFile', this.handleViewGoodsFile);
  },
  deactivated() {
    // keep-alive 缓存后离开页面时触发，精确移除当前组件的监听器
    this.$root.$off('viewReviewRecords', this.handleViewReviewRecords);
    this.$root.$off('viewGoodsFile', this.handleViewGoodsFile);
  },
  beforeDestroy() {
    // 组件销毁时移除监听器
    this.$root.$off('viewReviewRecords', this.handleViewReviewRecords);
    this.$root.$off('viewGoodsFile', this.handleViewGoodsFile);
  },
  methods: {
    handleViewReviewRecords(data) {
      console.log('data', data);
      
      this.openReviewRecords = false;
      
      this.$nextTick(() => {
        this.title = data.title;
        this.type = data.type;
        this.reviewList = Array.isArray(data.reviewList) ? [...data.reviewList] : [];
        this.currentTab = data.currentTab;
        this.$nextTick(() => {
          this.openReviewRecords = true;
        });
      });
    },
    handleViewGoodsFile(data) {
      this.openReviewRecords = data.openReviewRecords;
      this.title = data.title;
      this.type = data.type;
      this.reviewList = data.reviewList;
    },
    getApproveType(val) {
      let objStr = {
        Y: 'success',
        N: (this.type === 'service'||this.type === 'customer') ? 'danger' : 'warning',
        P: 'warning',
      };
      return objStr[val] || '-';
    },
    issusesFormat(list) {
      if ((list && list.length == 0) || !list) {
        return '-';
      }
      let resultArr = [];
      list.forEach((oneData, key) => {
        resultArr.push(key + 1 + '. ' + oneData.evaluationRuleDesc);
      });
      return resultArr.join('\n');
    },
    viewPicDetail(url) {
      if (url) window.open(url)
    },
    // 打开图片预览器
    openViewer(attach) {
      this.imageUrls = attach.map(item => item.path);
      this.showViewer = true;
      this.openReviewRecords = false;
    },
    // 关闭图片预览器
    closeViewer() {
      this.showViewer = false;
      this.openReviewRecords = true;
      this.imageUrls = [];
    },
     closedBox() {
      this.reviewList = []
      this.openReviewRecords = false
    }
  },
};
</script>

<style lang="less" scoped>
.el-timeline-item {
  // padding-bottom: 0px;
}
/deep/.el-dialog__header {
  border-bottom: 1px solid #d9d9d9;
}
.dialog-title {
  text-align: left;
  width: 240px;
  height: 27px;
  font-family: PingFang SC;
  font-size: 18px;
  color: #212121;
  letter-spacing: 0;
  line-height: 27px;
  font-weight: 400;
}
.operte-btns {
  text-align: right;
  border-top: 1px solid #d9d9d9;
  background: #fff;
  margin-top: 4px;
  display: flex;
  justify-content: center;
  padding: 15px 0;
}
.operte-btns .btn {
  padding: 5px 18px;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  cursor: pointer;
  margin-right: 10px;
}
.approve-history {
  max-height: 500px;
  overflow-y: auto;
  padding-right: 20px;
  .reason-text {
    color: #7f7f7f;
  }
}
.good-file {
  max-height: 700px;
  overflow-y: auto;
  padding-right: 20px;
}
</style>
